import { useMutation } from '@apollo/client'

import { UpdateOrderInternalCommentDocument } from '__generated__/atlas-types'

import { atlasClient } from 'graphql/client'
import { atlas } from 'graphql/tags'

atlas`#graphql
  mutation UpdateOrderInternalComment($input: UpdateOrderInfoInput) {
    updateOrderInfo(input: $input) {
      updatedOrders {
        edges {
          node {
            internalComments
          }
        }
      }
    }
  }
`

export const useUpdatePriceChanges = () => {
  const [mutate] = useMutation(UpdateOrderInternalCommentDocument, {
    client: atlasClient,
  })
  return {
    updateOrderInternalComment: (orderId: string, internalComments: string) => {
      return mutate({
        variables: {
          input: {
            orderIdentifiers: {
              orderIds: [orderId],
            },
            orderDetails: {
              internalComments,
            },
          },
        },
      })
    },
  }
}
